export { useRewritePaths } from './useRewritePaths';
